import React from "react";
import InfiniteScrolling from "../infinite-scrolling";
import ActiveUpload from "./active-upload";
import FetchActiveUploads from "./fetch-active-uploads";

import { ApolloProvider } from "react-apollo";
import client from "../../../helpers/apollo-client";

const InfiniteActiveUploads = ({ uploads, loadMoreUploads }) => {
    return (
        <section
            id="uploads"
            className="infinite-page user-icons container row"
        >
            <header className="col-xs-12 display-flex">
                <h3 className="ui_upload">Uploads</h3>
                <a className="back-link text-link" href="/dashboard">
                    Dashboard
                </a>
            </header>
            <ul id="icons-uploaded" className="col-xs-12 dashboard-user">
                {uploads.length ? (
                    <InfiniteScrolling
                        loadMore={loadMoreUploads}
                        elements={
                            uploads &&
                            uploads.map(upload => (
                                <ActiveUpload key={upload.id} upload={upload} />
                            ))
                        }
                    />
                ) : (
                    <h2>There aren't any uploads to show</h2>
                )}
            </ul>
        </section>
    );
};

export default function InfiniteActiveUploadsWrapper() {
    return (
        <ApolloProvider client={client}>
            <FetchActiveUploads limit={20} offset={0}>
                <InfiniteActiveUploads />
            </FetchActiveUploads>
        </ApolloProvider>
    );
}
